import { memo } from 'react'
import { Fab, styled } from '@mui/material'
import { EditOutlinedIcon } from '$common/icons'
import { showCreateNewChatModal } from '$comp/modals/new-chat'

const StyledFab = styled(Fab)`
  position: absolute;
  bottom: 68px;
  left: 12px;
`

export const CreateRoomFab = memo(() => {
  return (
    <StyledFab color="secondary" onClick={showCreateNewChatModal}>
      <EditOutlinedIcon />
    </StyledFab>
  )
})
